import { requests } from 'api';
import { HomelessnessSituation } from './types';

const apiBaseUrl = '/api/homelessness-situations';

export const HomelessnessSituationsApi = {
  getAll: (): Promise<HomelessnessSituation[]> => requests.get(apiBaseUrl),
};
